import { useQuery } from "@tanstack/react-query";
import { ListDefaultPlansQueryFilters, UseListDefaultPlansQueryOptions } from "./types";
import { getDefaultPlansService } from "./service";

export const listDefaultPlansQueryKey = ["default_plan_admin"];

export function useListDefaultPlansQuery(
  filters?: ListDefaultPlansQueryFilters,
  options?: UseListDefaultPlansQueryOptions
) {
  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listDefaultPlansQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getDefaultPlansService(filters),
    ...options,
  });
}
